import React from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

/**
 * 生成結構化數據標記
 * @param {string} type - 結構化數據類型，例如 'Organization', 'LocalBusiness', 等
 * @param {object} data - 結構化數據內容
 */
const StructuredData = ({ type, data }) => {
  // 組合結構化數據
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': type,
    ...data
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

// 常見結構化數據範本
export const organizationData = {
  type: 'Organization',
  data: {
    name: '凱撒數位科技股份有限公司',
    url: 'https://www.caesartechstudio.com',
    logo: 'https://www.caesartechstudio.com/assets/images/logo.png',
    sameAs: [
      'https://www.facebook.com/caesartechstudio',
      'https://www.instagram.com/caesartechstudio',
      'https://www.linkedin.com/company/caesartechstudio'
    ],
    address: {
      '@type': 'PostalAddress',
      streetAddress: '南新路341巷50號',
      addressLocality: '南投市',
      addressRegion: '南投縣',
      postalCode: '545',
      addressCountry: 'TW'
    },
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+886-4-9876-5432',
      contactType: 'customer service',
      email: 'karashuang@caesartechstudio.com'
    }
  }
};

export const localBusinessData = {
  type: 'LocalBusiness',
  data: {
    name: '凱撒數位科技股份有限公司',
    image: 'https://www.caesartechstudio.com/assets/images/og-default.png',
    '@id': 'https://www.caesartechstudio.com',
    url: 'https://www.caesartechstudio.com',
    telephone: '+886-4-9876-5432',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '南新路341巷50號',
      addressLocality: '南投市',
      addressRegion: '南投縣',
      postalCode: '545',
      addressCountry: 'TW'
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 23.850411,
      longitude: 120.682481
    },
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: [
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday'
        ],
        opens: '09:00',
        closes: '18:00'
      }
    ]
  }
};

export const professionalServiceData = {
  type: 'ProfessionalService',
  data: {
    name: '凱撒數位科技股份有限公司',
    description: '專業的網站設計與開發服務，幫助企業建立強大的線上形象。',
    url: 'https://www.caesartechstudio.com',
    telephone: '+886-4-9876-5432',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '南新路341巷50號',
      addressLocality: '南投市',
      addressRegion: '南投縣',
      postalCode: '545',
      addressCountry: 'TW'
    },
    priceRange: '$$',
    serviceType: ['網站設計', '網站開發', '應用程式開發', 'ESG數位轉型', 'AI導入', 'ERP', 'CRM', '雲端服務', '數據分析', '數位行銷']
  }
};

StructuredData.propTypes = {
  type: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired
};

export default StructuredData; 